import { IDs } from '../../../../helpers/IDs';
import { lazyInject } from '../../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../../core/trigger/trigger_service';
import { validateFieldUniversal } from '../../functions/validateField';
import { WFormsTableWrapper } from '../../../../core/table/WFormsTableWrapper';

export interface StandorteWaermepumpenProps {
    standortSelected: any;
    data: any;
}

export class StandorteWaermepumpen extends React.Component<StandorteWaermepumpenProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    preFilter(data: Array<any>): Array<any> {
        const { standortSelected } = this.props;

        return standortSelected
            ? data.filter((item: any) => (+item.standort_tid_orig || null) === standortSelected.tid)
            : data;
    }

    render(): JSX.Element {
        const { standortSelected } = this.props;

        return (
            <WFormsTableWrapper
                entity={IDs.ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN}
                module={IDs.MOD_ETOOL}
                actions={['add', 'edit', 'delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
                formPreset={{ standort_tid: standortSelected.tid }}
                customFormConfig={{
                    standort_tid: {
                        readonly: true
                    }
                }}
                validateField={this.validateField}
                preFilterFunction={this.preFilter}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN)}
                globalData={this.props.data}
            />
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN, key, value, data, onValueChange);
    }
}
